// @ts-ignore
import { orgAxios } from '../api/axios';

export const HBACandidateDataService = {
  getCandidateData,
};

async function getCandidateData(body: { candidateId: string }) {
  // @ts-ignore
  return await orgAxios.get(`/cds/candidate`, {
    params: { candidateId: body.candidateId },
  });
}
